import { useEffect } from 'react';

import { useTracker } from '../../../context/constructorContext';

interface IUseTrackShow {
  isInitial: boolean;
  isSearchCompleted: boolean;
  resultsSize: number | undefined;
}

export const useTrackShow = (params: IUseTrackShow): void => {
  const { isInitial, isSearchCompleted, resultsSize } = params;
  const trackerMethods = useTracker();

  useEffect(() => {
    if (!isInitial || !isSearchCompleted || !trackerMethods) {
      return;
    }

    const { trackShow } = trackerMethods;
    trackShow({
      results_size: resultsSize,
    });
  }, [isSearchCompleted]);
};
